<form id="companyIdModal" (ngSubmit)="confirm()">
  <div class="tw-flex tw-justify-end tw-mr-2">
    <button
      id="dismissButton"
      mat-icon-button
      type="button"
      class="close"
      (click)="dismiss()"
      aria-label="Click to close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="tw-text-center">Confirm Tenant Name</h4>
  <mat-dialog-content>
    <p class="mb-4">
      We've detected your organization's name for OneDrive as
      <b>{{ tenantName }}</b
      >. If this is incorrect, please ask your administrator for the correct
      name and update it below.
    </p>
    <div class="mb-4">
      <p class="mb-2"><strong>Tenant Name</strong></p>
      <input
        type="text"
        class="w-100 form-control"
        [(ngModel)]="tenantName"
        id="inputTenantName"
        name="inputTenantName"
      />
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-4">
    <button
      type="button"
      matButton="outlined"
      id="tenantNameCancelButton"
      (click)="dismiss()"
    >
      <span>Cancel</span>
    </button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      id="tenantNameConfirmButton"
      [disabled]="!tenantName"
    >
      <span>Confirm</span>
    </button>
  </mat-dialog-actions>
</form>
